import {inject, Injectable} from '@angular/core';
import {StorageService} from '@kilobytelab/core';
import {Alumno, Aviso, Circular, Evento, Informe, Padre, SemanaProyecto, SyncDeltas} from '@kilobytelab/types';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private storage = inject(StorageService);

  setSyncDeltas = (syncDeltas: SyncDeltas) => this.storage.setItem('SYNC_DELTAS', syncDeltas);
  getSyncDeltas = (): Promise<SyncDeltas> => this.storage.getItem('SYNC_DELTAS');
  setFechas = (fechas: {agendas: string, avisos: string}) => this.storage.setItem('FECHAS', fechas);
  getFechas = (): Promise<{agendas: string, avisos: string}> => this.storage.getItem('FECHAS');
  setAlumnoActual = (id: number) => this.storage.setItem('ALUMNO', id);
  getAlumnoActual = (): Promise<number> => this.storage.getItem('ALUMNO');
  setPadre = (alumnos: Alumno[]) => this.storage.setItem('PADRE', alumnos);
  getPadre = (): Promise<Alumno[]> => this.storage.getItem('PADRE');
  setPadres = (padres: [Padre, Padre]) => this.storage.setItem('PADRES', padres);
  getPadres = (): Promise<[Padre, Padre]> => this.storage.getItem('PADRES');
  setStateCirculares = (circulares: Circular[]) => this.storage.setItem('CIRCULARES', circulares);
  getStateCirculares = (): Promise<Circular[]> => this.storage.getItem('CIRCULARES');
  setTokenPush = (token: string) => this.storage.setItem('PUSH', token);
  getTokenPush = (): Promise<string> => this.storage.getItem('PUSH');
  setInformes = (informes: Informe[]) => this.storage.setItem('INFORMES', informes);
  getInformes = (): Promise<Informe[]> => this.storage.getItem('INFORMES');
  setAgenda = (agenda: {idAlumno: number, eventos: (Evento & Circular)[]}[]) => this.storage.setItem('AGENDA', agenda);
  getAgenda = (): Promise<{idAlumno: number, eventos: (Evento & Circular)[]}[]> => this.storage.getItem('AGENDA');
  setAvisos = (avisos: {idAlumno: number, avisos: Aviso[]}[]) => this.storage.setItem('AVISOS', avisos);
  getAvisos = (): Promise<{idAlumno: number, avisos: Aviso[]}[]> => this.storage.getItem('AVISOS');
  setProyectos = (proyectos: {tipo: string, proyecto: SemanaProyecto}[]) => this.storage.setItem('PROYECTO', proyectos);
  getProyectos = (): Promise<{tipo: string, proyecto: SemanaProyecto}[]> => this.storage.getItem('PROYECTO');
  getUltimoForceUpdate = (): Promise<number> => this.storage.getItem('LASTFORCEUPDATE');
  setUltimoForceUpdate = (lastForceUpdate: number) => this.storage.setItem('LASTFORCEUPDATE', lastForceUpdate);

}